import { render, staticRenderFns } from "./ContractSettings.vue?vue&type=template&id=c9961386&scoped=true"
import script from "./ContractSettings.vue?vue&type=script&lang=js"
export * from "./ContractSettings.vue?vue&type=script&lang=js"
import style0 from "./ContractSettings.vue?vue&type=style&index=0&id=c9961386&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9961386",
  null
  
)

export default component.exports